const Builder = require('../BuilderBase');

module.exports = class ToHexFromAscii extends Builder {
    constructor(properties) {
        super('transform_ToHexFromAscii', '', properties);
    }
};
